export const SEEN_LIBRARY_UPDATES_MODAL = 'seen_library_updates_modal';
